import { Feature } from "ol";
import { Point } from "ol/geom";
import { circular } from "ol/geom/Polygon";
import { fromLonLat } from "ol/proj";
import { Fill, Icon, Stroke, Style } from "ol/style";
import { ClientLayer } from "../../../lib/layers";
export class CurrentLocationLayer extends ClientLayer {
    constructor(p_layer, config, map) {
        super();
        this.p_layer = p_layer;
        this.map = map;
        this.watch_id = 0;
        this.zoomCounter = 0;
    }
    show() {
        let accuracyStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 255, 255, 0.2)',
            }),
            stroke: new Stroke({
                color: 'rgba(60, 130, 240, 0.5)',
                width: 2
            }),
        });
        let markerStyle = new Style({
            image: new Icon({
                anchor: [0.5, 1],
                src: '../../../../../../img/gis/map-marker-icon.png',
                scale: 0.05
            })
        });
        this.watch_id = navigator.geolocation.watchPosition(pos => {
            const coords = [pos.coords.longitude, pos.coords.latitude];
            const accuracy = circular(coords, pos.coords.accuracy);
            const accuracyCircle = new Feature(accuracy.transform('EPSG:4326', this.map.getView().getProjection()));
            accuracyCircle.setId(1);
            accuracyCircle.setStyle(accuracyStyle);
            const markerFeature = new Feature(new Point(fromLonLat(coords)));
            markerFeature.setStyle(markerStyle);
            this.source.clear(true);
            this.source.addFeatures([accuracyCircle, markerFeature]);
            this.zoomCounter++;
            if (this.zoomCounter === 1) {
                this.zoom();
            }
        }, error => console.error(`Location error. ${error.message}`), {
            enableHighAccuracy: true,
        });
    }
    zoom() {
        const accuracyCircle = this.source.getFeatureById(1);
        if (accuracyCircle) {
            let geom = accuracyCircle.getGeometry();
            this.map.getView().fit(geom.getExtent(), { padding: [100, 100, 100, 100] });
        }
    }
    hide() {
        navigator.geolocation.clearWatch(this.watch_id);
        this.source.clear(true);
        this.zoomCounter = 0;
    }
}
